import { PropsWithChildren, ReactNode } from 'react';

import { Box, Divider, Link } from '@mui/material';

export interface PromotionFooterFCProps {
  strings: {
    moreDetails: string;
    termsAndConditions: string;
    omnibusDisclaimer: string;
  };
  tacLink?: string;
  text?: string;
  preText?: ReactNode;
  shouldShowOmnibusDisclaimer?: boolean;
  hideTacText?: boolean;
}

export const PromotionFooterFC = (props: PropsWithChildren<PromotionFooterFCProps>) => {
  const { strings, text, tacLink, preText, shouldShowOmnibusDisclaimer, children } = props;
  return (
    <Box>
      <Box mb={3}>
        <Divider />
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
        <Box display="flex">{children}</Box>
        <Box sx={{ visibility: props.hideTacText ? 'hidden' : 'visible' }}>
          {preText}
          {text ?? strings.moreDetails}{' '}
          <Link target="_blank" href={tacLink}>
            {strings.termsAndConditions}
          </Link>
          {shouldShowOmnibusDisclaimer && !!strings.omnibusDisclaimer && (
            <>
              <br />
              {strings.omnibusDisclaimer}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
